import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import User from "@/pcm/store/models/User";
import Country from "@/pcm/store/models/Country";
import Contract from "@/pcm/store/models/Contract";
import Company from "@/pcm/store/models/Company";

export default class Network extends Model {
    static entity = 'networks';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            user_id: this.attr(null),
            country_id: this.attr(null),
            company_id: this.attr(null),
            name: this.string(''),
            contact: this.string(''),
            date_start: this.string(null),
            address: this.string(null),
            url: this.string(null).nullable(),
            zip: this.string(null),
            chamber_of_commerce: this.string(null),
            is_active: this.boolean(''),
            vat_number: this.string(null),

            network_fee_percentage: this.number(0).nullable(),
            network_fee_description: this.string(null).nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),

            // Relations
            user: this.belongsTo(User, 'user_id'),
            company: this.belongsTo(Company, 'company_id'),
            country: this.belongsTo(Country, 'country_id'),
            contracts: this.hasMany(Contract, 'network_id'),
        }
    }

    declare id: number;
    declare user_id: number;
    declare country_id: number;
    declare company_id: number;
    declare name: string;
    declare contact: string;
    declare date_start: string;
    declare address: string;
    declare url: string | null;
    declare zip: string;
    declare is_active: boolean;
    declare chamber_of_commerce: string;
    declare vat_number: string;

    declare network_fee_percentage: number | null;
    declare network_fee_description: string | null;

    declare contracts: Array<Contract>;
    declare country: Country;
    declare company: Company;
}
